import * as React from "react"
import styled from "styled-components";
import { Button } from "antd";

const Primary = styled(Button)`
    border-radius: 0;
    
    &&&& {
        color: ${props => props.theme.colors.white};
        
        &:hover {
            background-color: ${props => props.theme.colors.orangeDark};
            color: ${props => props.theme.colors.white};
        }
    }
`

const Link = styled(Button)`
    color: ${props => props.theme.colors.orange};
    
    &&&:hover {
        color: ${props => props.theme.colors.orangeDark};
    }
`

const PrimaryButton = ({ children, ...props }) => <Primary type="primary" {...props}>{children}</Primary>

const LinkButton = ({ children, ...props }) => <Link type="link" {...props}>{children}</Link>

export { PrimaryButton, LinkButton }
